import { webSearchToolSignature } from '@andsend/services/agent/shared';
import { makeAssistantToolUI } from '@assistant-ui/react';
import { GlobeIcon } from 'lucide-react';
import { z } from 'zod';

type WebSearchToolArgs = z.infer<typeof webSearchToolSignature.inputSchema>;
type WebSearchToolResult = z.infer<typeof webSearchToolSignature.outputSchema>;

const WebSearchUI = ({
    args,
    result,
    status,
}: {
    args: WebSearchToolArgs;
    result: WebSearchToolResult;
    status: 'running' | 'complete' | 'incomplete' | 'requires-action';
}) => {
    if (args.query === undefined) return null;
    return (
        <div className="flex flex-row items-center gap-2 w-fit">
            <GlobeIcon className="w-4 h-4" />
            {status === 'running' ? 'Searching' : 'Searched'} for "{args.query}"
        </div>
    );
};

export const WebSearchToolUI = makeAssistantToolUI<WebSearchToolArgs, WebSearchToolResult>({
    toolName: webSearchToolSignature.name,
    render: ({ args, result, status }) => WebSearchUI({ args, result, status: status.type }),
});

export const webSearchToolsUI = [WebSearchToolUI];
